import { default as React, FC } from 'react'
import { format } from 'date-fns'
import cn from 'classnames'
import Tooltip from '../../components/Tooltip'
import { TABLE_WIDTHS } from './Locations'
import { money } from '../../common/display'
import { ILocation } from '../../types/location'
import TypeBadge from '../../components/TypeBadge'

export interface ILocationsRowProps {
  location: ILocation
  showTypeColumn: boolean
  onClick: (location: ILocation) => void
  onEdit: (location: ILocation) => void
}

const LocationsRow: FC<ILocationsRowProps> = ({
  location,
  showTypeColumn,
  onClick,
  onEdit,
}) => {
  const lastCycleCountStatus = location.latestCycleCount?.status
  const lastCycleCountCompletedAt = location.latestCycleCount?.completedAt
  const lastCycleCountCountedAt = location.latestCycleCount?.countedAt

  return (
    <div
      className="table_tr -fixed-height -link"
      onClick={() => onClick(location)}
    >
      <div className={`table_td ${TABLE_WIDTHS.LOCATION_CODE} -truncate`}>
        {location.code}
      </div>
      {showTypeColumn && (
        <div className={`table_td ${TABLE_WIDTHS.TYPE}`}>
          <TypeBadge locationType={location.locationType} />
        </div>
      )}
      <div className={`table_td ${TABLE_WIDTHS.USER}`}>
        {location.user?.name || '-'}
      </div>
      <div className={`table_td ${TABLE_WIDTHS.TOTAL}`}>
        {money(location.totalValue?.toFixed(2) ?? '0.00')}
      </div>
      <div className={`table_td ${TABLE_WIDTHS.LAST_CYCLE_COUNT}`}>
        {lastCycleCountStatus !== 'completed' ? (
          <Tooltip id={`tooltip-updated-by-${location.id}`}>
            <div
              className="input_list-tooltip"
              data-tip={lastCycleCountStatus}
              data-for={`tooltip-updated-by-${location.id}`}
              data-effect="solid"
              data-place="bottom"
            >
              <span
                className={cn('table_text -dotted-underline', {
                  '-danger': lastCycleCountStatus === 'rejected',
                  '-warning': lastCycleCountStatus === 'pending',
                })}
              >
                {lastCycleCountCountedAt
                  ? format(lastCycleCountCountedAt, 'MMM D, YYYY')
                  : '-'}
              </span>
            </div>
          </Tooltip>
        ) : (
          <span className="table_text -success">
            {lastCycleCountCompletedAt
              ? format(lastCycleCountCompletedAt, 'MMM D, YYYY')
              : '-'}
          </span>
        )}
      </div>
      <div className={`table_td ${TABLE_WIDTHS.NEXT_CYCLE_COUNT}`}>
        {location.nextCycleCountDate ? (
          <span
            className={cn('table_text', {
              '-danger': location.cycleCountDue,
            })}
          >
            {format(location.nextCycleCountDate, 'MMM D, YYYY')}
          </span>
        ) : (
          <span className="table_text">-</span>
        )}
      </div>
      <div className={`table_td ${TABLE_WIDTHS.DESCRIPTION} -truncate`}>
        {location.description}
      </div>
      <div className={`table_td ${TABLE_WIDTHS.ACTIONS}`}>
        {!location.isDefault && (
          <div
            className="table-button"
            onClick={(e) => {
              e.stopPropagation()
              onEdit(location)
            }}
          >
            Edit
          </div>
        )}
      </div>
    </div>
  )
}

export default LocationsRow
